import type { ReactNode } from 'react';
import { Children } from 'react';

import {
  DetailListSectionHolder,
  DetailListSectionTitle,
} from './DetailListSection.styled';

type Props = {
  title: string;
  children: ReactNode;
};

export function DetailListSection({ title, children }: Props) {
  const isEmpty = Children.toArray(children).filter(Boolean).length === 0;
  if (isEmpty) return null;

  return (
    <DetailListSectionHolder>
      <DetailListSectionTitle>{title}:</DetailListSectionTitle>

      {children}
    </DetailListSectionHolder>
  );
}
